import React from 'react'

function DissmissReportModel(props) {
  const { handleconfirmDissmiss, handleCancelDissmiss } = props;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-lg p-6 max-w-sm w-full shadow-lg">
        <h2 className="text-lg font-semibold text-gray-800 mb-4">Confirm Dissmiss</h2>
        <p className="text-sm text-gray-600 mb-6">Are you sure you want to dissmiss?</p>
        <div className="flex justify-end gap-3">
          <button onClick={handleconfirmDissmiss} className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700">
            Ok
          </button>
          <button
            onClick={handleCancelDissmiss}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default DissmissReportModel